import { render, staticRenderFns } from "./IcoArrowInRightRectangle.vue?vue&type=template&id=09117b7b"
import script from "./IcoArrowInRightRectangle.vue?vue&type=script&lang=js"
export * from "./IcoArrowInRightRectangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports